<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative"
                                                type="button">
                                                <span>{{ $t('settings.New_reference') }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="bg-white">
                                        <div class="row mt-4">
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Code') }}</label>
                                                    <input v-model="state.code" type="text"
                                                        class="form-control form-control-default"
                                                        :placeholder="$t('settings.Code')">
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Name') }} *</label>
                                                    <input v-model="state.name" type="text"
                                                        class="form-control form-control-default"
                                                        :placeholder="$t('settings.Name')">
                                                    <span v-if="v$.name.$error" class="text-sm text-danger">
                                                        {{ v$.name.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Reference_type') }} *</label>
                                                    <select id="referenceTypeId" v-model="state.referenceTypeId"
                                                        class="form-control form-control-default">
                                                        <option value="">{{ $t('settings.Select_reference_type') }}
                                                        </option>
                                                        <option v-for="referencetype in state.referencetypes"
                                                            :key="referencetype.id" :value="referencetype.id">
                                                            {{ referencetype.name }}
                                                        </option>
                                                    </select>
                                                    <span v-if="v$.referenceTypeId.$error" class="text-sm text-danger">
                                                        {{ v$.referenceTypeId.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Description') }}</label>
                                                    <textarea class="form-control form-control-default" :rows="4"
                                                        v-model="state.description"
                                                        :placeholder="$t('settings.Description')"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 mt-4">
                                        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{
                                            $t('common.Cancel') }}</router-link>
                                        <button v-on:click="saveForm" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Save') }}</button> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import * as Choices from "choices.js";
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';

export default {
    name: 'Reference_create_page',

    setup() {

        const { t } = useI18n()

        const state = reactive({
            code: '',
            name: '',
            description: '',
            referenceTypeId: '',            
            referencetypes: [],
        })

        const rules = computed(() => {
            return {
                name: { required: helpers.withMessage(t('common.Required'), required) },
                referenceTypeId: { 
                    required: helpers.withMessage(t('common.Required'), required),
                    isSelected: helpers.withMessage(t('common.Select_a_reference_type'), value => value !== '')
                }
            }
        })

        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
            choicesInstance: null
        }
    },
    components: {
    },
    async mounted() {
        await this.fetchAllReferenceTypeData();
    },
    methods: {
        async fetchAllReferenceTypeData() {
            try {
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("ReferenceType/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.state.referencetypes = result.data;

                    this.$nextTick(() => {
                        this.initializeChoices();
                    });
                } else {     
                    this.$showError('errors.Error_fetching_reference_type');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        initializeChoices() {
            const element = document.getElementById("referenceTypeId");
            if (this.choicesInstance) {
                this.choicesInstance.destroy(); // Clean up previous instance
            }

            this.choicesInstance = new Choices(element, {
                searchEnabled: true,
                shouldSort: false,
                placeholder: true, 
                //placeholderValue: '-- Select reference type --', 
            });

            // Set the dropdown options
            if (Array.isArray(this.state.referencetypes) && this.state.referencetypes.length > 0) {
                // Check if the referenceTypeId exists among the registers
                if (this.state.referenceTypeId) {
                    const optionExists = this.state.referencetypes.some(x => x.id === this.state.referenceTypeId);
                    if (optionExists) {
                        this.choicesInstance.setChoiceByValue([this.state.referenceTypeId]); // Set the selected value
                    } else {
                        this.choicesInstance.setChoiceByValue(''); // Clear if no match found
                    }
                }
            }

            // Listen for changes and update state
            element.addEventListener('change', (event) => {
                this.state.referenceTypeId = event.target.value; // Update the state
                this.v$.$validate(); // Trigger validation
            });
        },
        async saveForm() {
            this.submitForm();
        },
        async submitForm() {
            // Put create logic
            try {
                // Trigger form validation
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    //console.log('Validation failed');
                    return;
                }

                
                this.$store.commit('setShowLoading', true);

                const response = await axios.post('Reference/save', {
                    "code": this.state.code,
                    "name": this.state.name,
                    "description": this.state.description,
                    "referenceTypeId": this.state.referenceTypeId
                });
                this.gets = response.data;

                if (this.gets.success) {
                    this.$showSuccess('errors.Success_reference_created_successfully');                    
                    this.$router.push('/settings');
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            }
            catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
            
            this.$store.commit('setShowLoading', false);
        }
    }
}
</script>
<style scoped>
.multisteps-form__progress-btn.js-active span {
    color: #fff !important;
}
</style>